import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardContent, Container, Typography, Link } from '@mui/material';
import { Logo } from '../components/Logo';
import { Title } from '../components/Title';

interface MessageProps {
    title: string;
    message: string;
    linkText?: string;
    linkUrl?: string;
    homeText?: string;
    homeUrl?: string;
}

const Message: FC<MessageProps> = ({ title, message, linkText, linkUrl, homeText, homeUrl }) => {
    if (!homeText) {
        homeText = 'Home';
    }
    if (!homeUrl) {
        homeUrl = '/';
    }

    return (
        <>
            <Title title={title} />
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                }}
            >
                <Container maxWidth="sm" sx={{ py: '60px' }}>
                    <Card elevation={6} sx={{ p: 4 }}>
                        <CardContent
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                p: 4,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <Box sx={{ pb: 2 }}>
                                    <RouterLink to="/">
                                        <Logo size={64} />
                                    </RouterLink>
                                </Box>
                                <Typography variant="h4">{title}</Typography>
                                <Typography sx={{ pt: 5 }}>{message}</Typography>
                                <Box
                                    sx={{
                                        pt: 3,
                                        display: 'flex',
                                        justifyContent: 'space-evenly',
                                        minWidth: '100%',
                                    }}
                                >
                                    <Link component={RouterLink} to={homeUrl}>
                                        {homeText}
                                    </Link>
                                    {linkText && (
                                        <Link component={RouterLink} to={linkUrl}>
                                            {linkText}
                                        </Link>
                                    )}
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Box>
        </>
    );
};
export default Message;
